import {
  AnimatePresence,
  m,
} from "framer-motion";
import type { Editor } from "@tiptap/react";
import { FloatingMenu } from "@tiptap/react";
import { generateFileURL } from "~/utils/file/generateFileURL";

import {
  useCallback,
  useRef,
  useState,
  type FC,
} from "react";
import clsx from "clsx";
import { posToDOMRect } from "~/utils/editorHelper";
import IconPicture from "../Icon/IconPicture";
import { useUpload } from "~/utils/file/uploadFileToR2";

import { FaListOl } from "@react-icons/all-files/fa/FaListOl";
import { FaListUl } from "@react-icons/all-files/fa/FaListUl";
import { easeUse } from "~/utils/easingUse";

//import { FloatingMenu } from "./FloatingMenu";

interface AppFloatMenuProps {
  editor: Editor;
  rect: DOMRect;
  setContent: () => void;
}

const fixMenuBtn = clsx(
  "w-40",
  "h-40",
  "border",
  "border-black",
  "flex",
  "items-center",
  "justify-center",
  "rounded-full",
  "bg-white",
  "cursor-pointer",
  "font-bold",
  "text-14",
  "relative",
);
const AppFloatMenu: FC<AppFloatMenuProps> = ({
  editor,
  rect,
  setContent,
}) => {
  const setSelection = useRef<any>([null, 0, 0]);
  const [isOpen, setIsOpen] = useState(false);
  const domRect = useRef<any>({});

  const menuClick = useCallback(
    (btnFunc: () => void) => {
      editor.commands.enter();
      btnFunc();
      setIsOpen(false);
    },
    [editor],
  );
  const addImage = useCallback(
    (key: string) => {
      const get = generateFileURL(key);
      console.log("get:", get);
      editor
        .chain()
        .focus()
        .setImage({ src: get })
        .run();
      setContent();
    },
    [editor, setContent],
  );
  const { imageSelect } = useUpload(addImage);

  return (
    <>
      <FloatingMenu
        className={clsx(
          "left-0",
          "relative",
          "floating-menu",
          "pointer-events-auto",
        )}
        tippyOptions={{
          duration: 100,
          /* followCursor: false,
          sticky: false,
          inlinePositioning: false, */
          interactive: false,
          placement: "auto",
          getReferenceClientRect: () => {
            domRect.current = posToDOMRect(
              editor.view,
              editor.view.state.selection.from,
              editor.view.state.selection.to,
            );
            return posToDOMRect(
              editor.view,
              editor.view.state.selection.from,
              editor.view.state.selection.to,
            );
          },
        }}
        editor={editor}
        shouldShow={(props) => {
          const { selection } = props.state;
          //setSelection([props.view, selection.from, selection.to]);
          setSelection.current = [
            props.view,
            selection.from,
            selection.to,
          ];
          return true;
        }}
      >
        <div
          style={{
            transform: `translate(${rect.left - 15}px, ${-15}px)`,
          }}
        >
          <div
            className={clsx(
              "translate-x-[-100%]",
              "translate-y-[50%]",
              "relative",
              "max-md:translate-x-[-0%]",
              "max-md:translate-y-[150%]",
            )}
          >
            <div
              className={clsx(fixMenuBtn)}
              onClick={() => setIsOpen(!isOpen)}
            >
              <div
                className={clsx(
                  "relative h-[50%] w-[50%]",
                  isOpen ? "rotate-45" : "",
                )}
              >
                <div
                  className={clsx(
                    "w-full",
                    "h-[1px]",
                    "bg-black",
                    "absolute",
                    "left-0",
                    "top-0",
                    "translate-y-9",
                  )}
                ></div>
                <div
                  className={clsx(
                    "w-full",
                    "h-[1px]",
                    "bg-black",
                    "absolute",
                    "left-0",
                    "top-0",
                    "translate-y-9",
                    "rotate-90",
                  )}
                ></div>
              </div>
            </div>
            <AnimatePresence>
              {isOpen && (
                <m.div
                  exit={{ opacity: 0 }}
                  initial={{
                    opacity: 0,
                    x: "-10px",
                  }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{
                    x: {
                      ...easeUse("easeOutQuint", {
                        duration: 0.6,
                      }),
                    },
                    opacity: {
                      ...easeUse(
                        "easeInOutSine",
                        {
                          duration: 0.3,
                        },
                      ),
                    },
                  }}
                  className={clsx(
                    "flex",
                    "flex-col",
                    "gap-10",
                    "absolute",
                    "left-[125%]",
                    "top-0",
                  )}
                >
                  <button
                    className={clsx(
                      fixMenuBtn,
                      editor.isActive(
                        "bulletList",
                      )
                        ? "is-active"
                        : "",
                    )}
                  >
                    <input
                      className={clsx(
                        "absolute left-0 top-0 h-full w-full cursor-pointer opacity-0",
                      )}
                      type="file"
                      onChange={(e) => {
                        const file =
                          e.target.files?.[0];
                        console.log(
                          "file:",
                          file,
                        );
                        if (file) {
                          imageSelect(file);
                        }
                      }}
                    />

                    <div
                      className={clsx("w-[50%]")}
                    >
                      <IconPicture></IconPicture>
                    </div>
                  </button>

                  <button
                    onClick={(e) => {
                      console.log("111:", 111);
                      menuClick(() => {
                        editor
                          .chain()
                          .focus()
                          .toggleHeading({
                            level: 1,
                          })
                          .run();
                      });
                    }}
                    className={clsx(
                      fixMenuBtn,
                      editor.isActive("heading", {
                        level: 1,
                      })
                        ? "is-active"
                        : "",
                    )}
                  >
                    H1
                  </button>
                  <button
                    onClick={() => {
                      menuClick(() => {
                        editor
                          .chain()
                          .focus()
                          .toggleHeading({
                            level: 2,
                          })
                          .run();
                      });
                    }}
                    className={clsx(
                      fixMenuBtn,
                      editor.isActive("heading", {
                        level: 2,
                      })
                        ? "is-active"
                        : "",
                    )}
                  >
                    H2
                  </button>
                  <button
                    onClick={() => {
                      menuClick(() => {
                        editor
                          .chain()
                          .focus()
                          .toggleHeading({
                            level: 2,
                          })
                          .run();
                      });
                    }}
                    className={clsx(
                      fixMenuBtn,
                      editor.isActive("heading", {
                        level: 3,
                      })
                        ? "is-active"
                        : "",
                    )}
                  >
                    H3
                  </button>

                  <button
                    onClick={() =>
                      editor
                        .chain()
                        .focus()
                        .toggleBulletList()
                        .run()
                    }
                    className={clsx(
                      fixMenuBtn,
                      editor.isActive(
                        "bulletList",
                      )
                        ? "is-active"
                        : "",
                    )}
                  >
                    <FaListUl />
                  </button>
                  <button
                    onClick={() =>
                      editor
                        .chain()
                        .focus()
                        .toggleOrderedList()
                        .run()
                    }
                    className={clsx(
                      fixMenuBtn,
                      editor.isActive(
                        "orderedList",
                      )
                        ? "is-active"
                        : "",
                    )}
                  >
                    <FaListOl />
                  </button>
                </m.div>
              )}
            </AnimatePresence>
          </div>
        </div>
      </FloatingMenu>
    </>
  );
};

export default AppFloatMenu;
